
import { defineComponent, ref, Ref } from 'vue';
import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';
import WebApiMessage from '@/core/http/WebApiMessage.vue';
import { Form } from 'vee-validate';
import offerStore from '@/b2c/offers/offers.store';
import { router } from '@/core/router';

export const findPersonalOfferWebApiMessageKey = 'findPersonalOfferApiMessages';

export default defineComponent({
    name: 'FindPersonalOffer',
    components: { WebApiMessage, Form },
    props: {
        detailsUrl: {
            type: String,
            required: true,
        },
        autoFindId: {
            type: String,
            required: false,
            default: '',
        },
        addToBasket: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    setup(props) {
        const labels = useBlockLabels();
        const pending: Ref<boolean> = ref(false);

        const redirect = (id: string, addtoBasket: boolean): void => {
            const location = offerStore.getDetailsLocation(id, props.detailsUrl, addtoBasket);
            router.push(location);
        };

        const submit = async({ id, addToBasket }): Promise<void> => {
            if (pending.value) {
                return;
            }
            pending.value = true;
            try {
                const valid = await offerStore.isValidOfferId(id, findPersonalOfferWebApiMessageKey);
                valid && redirect(id, addToBasket);
            } finally {
                pending.value = false;
            }
        };

        const formValidation = {
            id: 'required',
        };

        props.autoFindId && submit({ id: props.autoFindId, addToBasket: props.addToBasket });

        return {
            labels,
            pending,
            submit,
            findPersonalOfferWebApiMessageKey,
            formValidation,
        };
    },
});
